import { Controller } from "@hotwired/stimulus";

// GO4TEACH lot 24 « Animer la classe »: the draw by seat number. Nobody is drawn twice until the
// whole class has had a turn; then « Recommencer » starts a new round. Kept in this browser per
// account and course (nothing is sent, no AI): the draw survives a reload during the lesson.
const PREFIX = "g4t-class-draw:";

export default class extends Controller {
  static targets = ["size", "result", "remaining", "history", "button"];
  static values = { key: String, size: Number, remaining: String };

  connect() {
    this.storageKey = `${PREFIX}${this.keyValue}`;
    const kept = this.read();
    this.state = kept || { size: this.sizeValue, drawn: [] };
    this.sizeTarget.value = this.state.size;
    this.show();
  }

  read() {
    try {
      const kept = JSON.parse(window.localStorage.getItem(this.storageKey) || "null");
      return kept && Number.isInteger(kept.size) && Array.isArray(kept.drawn) ? kept : null;
    } catch (_error) {
      return null;
    }
  }

  write() {
    try {
      window.localStorage.setItem(this.storageKey, JSON.stringify(this.state));
    } catch (_error) {
      // Private browsing or storage full: the draw still works for this page.
    }
  }

  get left() {
    const drawn = new Set(this.state.drawn);
    const seats = [];
    for (let seat = 1; seat <= this.state.size; seat += 1) if (!drawn.has(seat)) seats.push(seat);
    return seats;
  }

  draw() {
    const left = this.left;
    if (left.length === 0) return;
    const seat = left[Math.floor(Math.random() * left.length)];
    this.state.drawn.push(seat);
    this.write();
    this.show(seat);
  }

  reset() {
    this.state.drawn = [];
    this.write();
    this.show();
  }

  // A new class size starts a new round: the seats drawn may no longer exist.
  resize() {
    const size = parseInt(this.sizeTarget.value, 10);
    if (!Number.isFinite(size) || size < 1) return;
    this.state = { size: Math.min(size, 150), drawn: [] };
    this.write();
    this.show();
  }

  show(seat) {
    const last = seat ?? this.state.drawn[this.state.drawn.length - 1];
    this.resultTarget.textContent = last ? String(last) : "—";
    const count = this.left.length;
    const words = JSON.parse(this.remainingValue);
    const text = count === 0 ? words.zero : count === 1 ? words.one : words.other.replace("%{count}", count);
    this.remainingTarget.textContent = text;
    this.buttonTarget.disabled = count === 0;
    this.historyTarget.replaceChildren(
      ...this.state.drawn.map((drawn) => {
        const chip = document.createElement("span");
        chip.className = "ds-text-meta";
        chip.style.cssText = "min-width: 28px; padding: 2px 6px; border-radius: 8px; border: 1px solid var(--ds-border); text-align: center; font: 600 12px var(--g4s-font-mono);";
        chip.textContent = String(drawn);
        return chip;
      }),
    );
  }
}
